import {handleActions} from 'redux-actions';

import {GET_VARIABLES} from '/redux/action/remoteConfig.action';
import {withPayload} from '/util/reducer.util';

import {getVariables} from './remoteConfig/getVariables';

const initialState = {
  variables: {},
};

export const remoteConfig = handleActions(
  {
    [GET_VARIABLES]: withPayload(getVariables),
  },
  initialState,
);
